/**
 * Path to the Route Handler that ends the session: it clears the app session
 * and the selected-environment cookie, then redirects to the identity
 * provider's hosted logout. Shared by the Sign out button and the server-side
 * exit for a session that has lost its access token.
 */
export const LOGOUT_ROUTE = '/api/auth/cognito-logout'

/** Query value that marks a sign-out the app started because the token was gone. */
export const SESSION_EXPIRED_REASON = 'expired'

/** Where the server sends a session that has lost its access token. */
export const SESSION_EXPIRED_ROUTE = `${LOGOUT_ROUTE}?reason=${SESSION_EXPIRED_REASON}`
